// extracted by mini-css-extract-plugin
export var grow = "layout-module--grow--31b3b";
export var wrapper = "layout-module--wrapper--f9f57";